module.exports = __webpack_public_path__ + "static/media/perfil3.31668303.png";